// src/data/serieACalendar.js
// Calendario ufficiale Serie A Enilive 2026/27 (fonte: PDF Lega Serie A).
// Dato statico: il calendario è stato sorteggiato e non cambia più.
// Ogni giornata: data di riferimento (YYYY-MM-DD) e 10 partite [casa, trasferta].

export const SERIE_A_SEASON_LABEL = 'Serie A 2026/27';

export const SERIE_A_CALENDAR = [
  {
    giornata: 1,
    date: '2026-08-23',
    matches: [
      ['Atalanta', 'Sassuolo'], ['Bologna', 'Lazio'], ['Frosinone', 'Juventus'],
      ['Genoa', 'Napoli'], ['Inter', 'Monza'], ['Parma', 'Cagliari'],
      ['Roma', 'Fiorentina'], ['Torino', 'Milan'], ['Udinese', 'Como'], ['Venezia', 'Lecce'],
    ],
  },
  {
    giornata: 2,
    date: '2026-08-30',
    matches: [
      ['Atalanta', 'Bologna'], ['Cagliari', 'Inter'], ['Fiorentina', 'Frosinone'],
      ['Juventus', 'Parma'], ['Lazio', 'Genoa'], ['Lecce', 'Roma'],
      ['Milan', 'Venezia'], ['Monza', 'Udinese'], ['Napoli', 'Como'], ['Sassuolo', 'Torino'],
    ],
  },
  {
    giornata: 3,
    date: '2026-09-06',
    matches: [
      ['Bologna', 'Sassuolo'], ['Cagliari', 'Lecce'], ['Fiorentina', 'Torino'],
      ['Frosinone', 'Venezia'], ['Genoa', 'Como'], ['Inter', 'Napoli'],
      ['Juventus', 'Milan'], ['Parma', 'Monza'], ['Roma', 'Atalanta'], ['Udinese', 'Lazio'],
    ],
  },
  {
    giornata: 4,
    date: '2026-09-13',
    matches: [
      ['Atalanta', 'Cagliari'], ['Como', 'Parma'], ['Genoa', 'Frosinone'],
      ['Inter', 'Udinese'], ['Lazio', 'Milan'], ['Lecce', 'Monza'],
      ['Napoli', 'Bologna'], ['Sassuolo', 'Juventus'], ['Torino', 'Roma'], ['Venezia', 'Fiorentina'],
    ],
  },
  {
    giornata: 5,
    date: '2026-09-20',
    matches: [
      ['Bologna', 'Torino'], ['Fiorentina', 'Napoli'], ['Frosinone', 'Como'],
      ['Juventus', 'Atalanta'], ['Milan', 'Lecce'], ['Monza', 'Sassuolo'],
      ['Parma', 'Genoa'], ['Roma', 'Inter'], ['Udinese', 'Cagliari'], ['Venezia', 'Lazio'],
    ],
  },
  {
    giornata: 6,
    date: '2026-10-11',
    matches: [
      ['Atalanta', 'Venezia'], ['Cagliari', 'Juventus'], ['Como', 'Roma'],
      ['Genoa', 'Fiorentina'], ['Inter', 'Parma'], ['Lazio', 'Monza'],
      ['Lecce', 'Bologna'], ['Napoli', 'Frosinone'], ['Sassuolo', 'Milan'], ['Torino', 'Udinese'],
    ],
  },
  {
    giornata: 7,
    date: '2026-10-18',
    matches: [
      ['Bologna', 'Inter'], ['Fiorentina', 'Como'], ['Frosinone', 'Sassuolo'],
      ['Juventus', 'Lazio'], ['Milan', 'Atalanta'], ['Monza', 'Cagliari'],
      ['Parma', 'Torino'], ['Roma', 'Genoa'], ['Udinese', 'Lecce'], ['Venezia', 'Napoli'],
    ],
  },
  {
    giornata: 8,
    date: '2026-10-25',
    matches: [
      ['Atalanta', 'Frosinone'], ['Cagliari', 'Bologna'], ['Como', 'Sassuolo'],
      ['Genoa', 'Venezia'], ['Inter', 'Fiorentina'], ['Lazio', 'Parma'],
      ['Lecce', 'Juventus'], ['Napoli', 'Roma'], ['Torino', 'Monza'], ['Udinese', 'Milan'],
    ],
  },
  {
    giornata: 9,
    date: '2026-10-28',
    matches: [
      ['Fiorentina', 'Atalanta'], ['Frosinone', 'Lecce'], ['Genoa', 'Juventus'],
      ['Milan', 'Bologna'], ['Monza', 'Napoli'], ['Parma', 'Udinese'],
      ['Roma', 'Cagliari'], ['Sassuolo', 'Lazio'], ['Torino', 'Como'], ['Venezia', 'Inter'],
    ],
  },
  {
    giornata: 10,
    date: '2026-11-01',
    matches: [
      ['Atalanta', 'Parma'], ['Bologna', 'Monza'], ['Como', 'Venezia'],
      ['Frosinone', 'Torino'], ['Juventus', 'Napoli'], ['Lazio', 'Cagliari'],
      ['Lecce', 'Genoa'], ['Milan', 'Inter'], ['Sassuolo', 'Fiorentina'], ['Udinese', 'Roma'],
    ],
  },
  {
    giornata: 11,
    date: '2026-11-08',
    matches: [
      ['Cagliari', 'Frosinone'], ['Fiorentina', 'Juventus'], ['Genoa', 'Milan'],
      ['Inter', 'Como'], ['Monza', 'Atalanta'], ['Napoli', 'Lazio'],
      ['Parma', 'Bologna'], ['Roma', 'Sassuolo'], ['Torino', 'Lecce'], ['Venezia', 'Udinese'],
    ],
  },
  {
    giornata: 12,
    date: '2026-11-22',
    matches: [
      ['Atalanta', 'Inter'], ['Bologna', 'Udinese'], ['Como', 'Cagliari'],
      ['Juventus', 'Venezia'], ['Lazio', 'Lecce'], ['Milan', 'Frosinone'],
      ['Monza', 'Fiorentina'], ['Napoli', 'Torino'], ['Parma', 'Roma'], ['Sassuolo', 'Genoa'],
    ],
  },
  {
    giornata: 13,
    date: '2026-11-29',
    matches: [
      ['Cagliari', 'Milan'], ['Como', 'Juventus'], ['Frosinone', 'Parma'],
      ['Inter', 'Genoa'], ['Lecce', 'Atalanta'], ['Roma', 'Monza'],
      ['Sassuolo', 'Napoli'], ['Torino', 'Lazio'], ['Udinese', 'Fiorentina'], ['Venezia', 'Bologna'],
    ],
  },
  {
    giornata: 14,
    date: '2026-12-06',
    matches: [
      ['Bologna', 'Roma'], ['Fiorentina', 'Cagliari'], ['Frosinone', 'Inter'],
      ['Genoa', 'Torino'], ['Juventus', 'Udinese'], ['Lazio', 'Atalanta'],
      ['Milan', 'Parma'], ['Monza', 'Como'], ['Napoli', 'Lecce'], ['Venezia', 'Sassuolo'],
    ],
  },
  {
    giornata: 15,
    date: '2026-12-13',
    matches: [
      ['Atalanta', 'Genoa'], ['Cagliari', 'Venezia'], ['Como', 'Bologna'],
      ['Inter', 'Torino'], ['Juventus', 'Monza'], ['Lazio', 'Roma'],
      ['Lecce', 'Sassuolo'], ['Napoli', 'Milan'], ['Parma', 'Fiorentina'], ['Udinese', 'Frosinone'],
    ],
  },
  {
    giornata: 16,
    date: '2026-12-20',
    matches: [
      ['Atalanta', 'Napoli'], ['Fiorentina', 'Bologna'], ['Frosinone', 'Lazio'],
      ['Genoa', 'Udinese'], ['Lecce', 'Inter'], ['Milan', 'Como'],
      ['Roma', 'Juventus'], ['Sassuolo', 'Parma'], ['Torino', 'Cagliari'], ['Venezia', 'Monza'],
    ],
  },
  {
    giornata: 17,
    date: '2027-01-03',
    matches: [
      ['Bologna', 'Juventus'], ['Cagliari', 'Genoa'], ['Como', 'Lecce'],
      ['Fiorentina', 'Lazio'], ['Inter', 'Sassuolo'], ['Monza', 'Milan'],
      ['Parma', 'Napoli'], ['Roma', 'Frosinone'], ['Torino', 'Venezia'], ['Udinese', 'Atalanta'],
    ],
  },
  {
    giornata: 18,
    date: '2027-01-06',
    matches: [
      ['Atalanta', 'Como'], ['Frosinone', 'Bologna'], ['Genoa', 'Monza'],
      ['Juventus', 'Torino'], ['Lazio', 'Inter'], ['Lecce', 'Parma'],
      ['Milan', 'Fiorentina'], ['Napoli', 'Cagliari'], ['Sassuolo', 'Udinese'], ['Venezia', 'Roma'],
    ],
  },
  {
    giornata: 19,
    date: '2027-01-10',
    matches: [
      ['Bologna', 'Genoa'], ['Cagliari', 'Sassuolo'], ['Como', 'Lazio'],
      ['Fiorentina', 'Lecce'], ['Inter', 'Juventus'], ['Monza', 'Frosinone'],
      ['Parma', 'Venezia'], ['Roma', 'Milan'], ['Torino', 'Atalanta'], ['Udinese', 'Napoli'],
    ],
  },
  {
    giornata: 20,
    date: '2027-01-17',
    matches: [
      ['Atalanta', 'Roma'], ['Cagliari', 'Como'], ['Juventus', 'Genoa'],
      ['Lazio', 'Bologna'], ['Lecce', 'Udinese'], ['Milan', 'Torino'],
      ['Napoli', 'Fiorentina'], ['Parma', 'Inter'], ['Sassuolo', 'Monza'], ['Venezia', 'Frosinone'],
    ],
  },
  {
    giornata: 21,
    date: '2027-01-24',
    matches: [
      ['Bologna', 'Atalanta'], ['Como', 'Napoli'], ['Fiorentina', 'Sassuolo'],
      ['Frosinone', 'Milan'], ['Genoa', 'Parma'], ['Inter', 'Venezia'],
      ['Juventus', 'Cagliari'], ['Lecce', 'Torino'], ['Monza', 'Lazio'], ['Roma', 'Udinese'],
    ],
  },
  {
    giornata: 22,
    date: '2027-01-31',
    matches: [
      ['Atalanta', 'Fiorentina'], ['Cagliari', 'Parma'], ['Genoa', 'Lecce'],
      ['Lazio', 'Venezia'], ['Milan', 'Juventus'], ['Monza', 'Roma'],
      ['Napoli', 'Inter'], ['Sassuolo', 'Como'], ['Torino', 'Frosinone'], ['Udinese', 'Bologna'],
    ],
  },
  {
    giornata: 23,
    date: '2027-02-07',
    matches: [
      ['Atalanta', 'Lazio'], ['Bologna', 'Milan'], ['Como', 'Monza'],
      ['Fiorentina', 'Udinese'], ['Inter', 'Cagliari'], ['Juventus', 'Sassuolo'],
      ['Lecce', 'Napoli'], ['Parma', 'Frosinone'], ['Roma', 'Torino'], ['Venezia', 'Genoa'],
    ],
  },
  {
    giornata: 24,
    date: '2027-02-14',
    matches: [
      ['Bologna', 'Como'], ['Cagliari', 'Lazio'], ['Frosinone', 'Fiorentina'],
      ['Genoa', 'Atalanta'], ['Inter', 'Milan'], ['Monza', 'Lecce'],
      ['Napoli', 'Juventus'], ['Roma', 'Parma'], ['Torino', 'Sassuolo'], ['Udinese', 'Venezia'],
    ],
  },
  {
    giornata: 25,
    date: '2027-02-21',
    matches: [
      ['Atalanta', 'Monza'], ['Como', 'Torino'], ['Fiorentina', 'Inter'],
      ['Juventus', 'Bologna'], ['Lazio', 'Napoli'], ['Lecce', 'Frosinone'],
      ['Milan', 'Genoa'], ['Sassuolo', 'Roma'], ['Udinese', 'Parma'], ['Venezia', 'Cagliari'],
    ],
  },
  {
    giornata: 26,
    date: '2027-02-28',
    matches: [
      ['Bologna', 'Lecce'], ['Cagliari', 'Udinese'], ['Como', 'Milan'],
      ['Frosinone', 'Napoli'], ['Genoa', 'Lazio'], ['Inter', 'Atalanta'],
      ['Monza', 'Juventus'], ['Parma', 'Sassuolo'], ['Roma', 'Venezia'], ['Torino', 'Fiorentina'],
    ],
  },
  {
    giornata: 27,
    date: '2027-03-07',
    matches: [
      ['Atalanta', 'Torino'], ['Fiorentina', 'Venezia'], ['Juventus', 'Roma'],
      ['Lazio', 'Frosinone'], ['Lecce', 'Como'], ['Milan', 'Cagliari'],
      ['Monza', 'Genoa'], ['Napoli', 'Parma'], ['Sassuolo', 'Bologna'], ['Udinese', 'Inter'],
    ],
  },
  {
    giornata: 28,
    date: '2027-03-14',
    matches: [
      ['Bologna', 'Napoli'], ['Cagliari', 'Fiorentina'], ['Como', 'Udinese'],
      ['Frosinone', 'Monza'], ['Genoa', 'Roma'], ['Lazio', 'Juventus'],
      ['Milan', 'Sassuolo'], ['Parma', 'Lecce'], ['Torino', 'Inter'], ['Venezia', 'Atalanta'],
    ],
  },
  {
    giornata: 29,
    date: '2027-03-21',
    matches: [
      ['Atalanta', 'Milan'], ['Fiorentina', 'Genoa'], ['Inter', 'Frosinone'],
      ['Juventus', 'Como'], ['Monza', 'Bologna'], ['Napoli', 'Venezia'],
      ['Parma', 'Lazio'], ['Roma', 'Lecce'], ['Sassuolo', 'Cagliari'], ['Udinese', 'Torino'],
    ],
  },
  {
    giornata: 30,
    date: '2027-04-04',
    matches: [
      ['Cagliari', 'Napoli'], ['Como', 'Fiorentina'], ['Frosinone', 'Udinese'],
      ['Genoa', 'Inter'], ['Lecce', 'Lazio'], ['Milan', 'Monza'],
      ['Roma', 'Bologna'], ['Sassuolo', 'Atalanta'], ['Torino', 'Juventus'], ['Venezia', 'Parma'],
    ],
  },
  {
    giornata: 31,
    date: '2027-04-11',
    matches: [
      ['Bologna', 'Venezia'], ['Cagliari', 'Atalanta'], ['Fiorentina', 'Milan'],
      ['Frosinone', 'Genoa'], ['Inter', 'Roma'], ['Juventus', 'Lecce'],
      ['Lazio', 'Torino'], ['Napoli', 'Sassuolo'], ['Parma', 'Como'], ['Udinese', 'Monza'],
    ],
  },
  {
    giornata: 32,
    date: '2027-04-18',
    matches: [
      ['Atalanta', 'Udinese'], ['Bologna', 'Cagliari'], ['Como', 'Frosinone'],
      ['Fiorentina', 'Parma'], ['Milan', 'Napoli'], ['Monza', 'Inter'],
      ['Roma', 'Lazio'], ['Sassuolo', 'Lecce'], ['Torino', 'Genoa'], ['Venezia', 'Juventus'],
    ],
  },
  {
    giornata: 33,
    date: '2027-04-25',
    matches: [
      ['Cagliari', 'Monza'], ['Frosinone', 'Roma'], ['Genoa', 'Sassuolo'],
      ['Inter', 'Bologna'], ['Juventus', 'Fiorentina'], ['Lazio', 'Como'],
      ['Lecce', 'Milan'], ['Napoli', 'Udinese'], ['Parma', 'Atalanta'], ['Venezia', 'Torino'],
    ],
  },
  {
    giornata: 34,
    date: '2027-05-02',
    matches: [
      ['Atalanta', 'Juventus'], ['Bologna', 'Fiorentina'], ['Como', 'Inter'],
      ['Lecce', 'Cagliari'], ['Milan', 'Lazio'], ['Monza', 'Venezia'],
      ['Roma', 'Napoli'], ['Sassuolo', 'Frosinone'], ['Torino', 'Parma'], ['Udinese', 'Genoa'],
    ],
  },
  {
    giornata: 35,
    date: '2027-05-09',
    matches: [
      ['Fiorentina', 'Roma'], ['Frosinone', 'Atalanta'], ['Genoa', 'Cagliari'],
      ['Inter', 'Lecce'], ['Lazio', 'Sassuolo'], ['Napoli', 'Monza'],
      ['Parma', 'Milan'], ['Torino', 'Bologna'], ['Udinese', 'Juventus'], ['Venezia', 'Como'],
    ],
  },
  {
    giornata: 36,
    date: '2027-05-16',
    matches: [
      ['Bologna', 'Frosinone'], ['Cagliari', 'Torino'], ['Como', 'Atalanta'],
      ['Juventus', 'Inter'], ['Lazio', 'Udinese'], ['Lecce', 'Fiorentina'],
      ['Milan', 'Roma'], ['Monza', 'Parma'], ['Napoli', 'Genoa'], ['Sassuolo', 'Venezia'],
    ],
  },
  {
    giornata: 37,
    date: '2027-05-23',
    matches: [
      ['Atalanta', 'Lecce'], ['Fiorentina', 'Monza'], ['Frosinone', 'Cagliari'],
      ['Genoa', 'Bologna'], ['Inter', 'Lazio'], ['Parma', 'Juventus'],
      ['Roma', 'Como'], ['Torino', 'Napoli'], ['Udinese', 'Sassuolo'], ['Venezia', 'Milan'],
    ],
  },
  {
    giornata: 38,
    date: '2027-05-30',
    matches: [
      ['Bologna', 'Parma'], ['Cagliari', 'Roma'], ['Como', 'Genoa'],
      ['Juventus', 'Frosinone'], ['Lazio', 'Fiorentina'], ['Lecce', 'Venezia'],
      ['Milan', 'Udinese'], ['Monza', 'Torino'], ['Napoli', 'Atalanta'], ['Sassuolo', 'Inter'],
    ],
  },
];

// ─── Squadre e normalizzazione nomi ──────────────────────────────────────────

export const SERIE_A_TEAMS = [
  'Atalanta', 'Bologna', 'Cagliari', 'Como', 'Fiorentina', 'Frosinone', 'Genoa',
  'Inter', 'Juventus', 'Lazio', 'Lecce', 'Milan', 'Monza', 'Napoli', 'Parma',
  'Roma', 'Sassuolo', 'Torino', 'Udinese', 'Venezia',
];

function normalizeTeamKey(teamName = '') {
  return String(teamName)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z]/g, '');
}

// Alias per sorgenti dati che usano nomi diversi da quelli del calendario.
const TEAM_KEY_ALIASES = {
  internazionale: 'inter',
  acmilan: 'milan',
  juve: 'juventus',
  hellasverona: 'verona',
};

function resolveTeamKey(teamName = '') {
  const key = normalizeTeamKey(teamName);
  return TEAM_KEY_ALIASES[key] || key;
}

// ─── Difficoltà avversario ────────────────────────────────────────────────────
// Livello di difficoltà nell'affrontare ogni squadra (1 = molto abbordabile,
// 5 = big match). Stima statica pre-stagione basata sulla forza attesa delle
// rose 2026/27: usata per pesare il calendario nelle analisi (es. scambi).

export const TEAM_DIFFICULTY = {
  Atalanta: 4,
  Bologna: 3,
  Cagliari: 2,
  Como: 4,
  Fiorentina: 4,
  Frosinone: 1,
  Genoa: 2.5,
  Inter: 5,
  Juventus: 5,
  Lazio: 3.5,
  Lecce: 1,
  Milan: 5,
  Monza: 1,
  Napoli: 5,
  Parma: 2,
  Roma: 4.5,
  Sassuolo: 2,
  Torino: 3,
  Udinese: 2.5,
  Venezia: 1,
};

const DEFAULT_TEAM_DIFFICULTY = 3;

let difficultyIndexCache = null;

function buildDifficultyIndex() {
  if (difficultyIndexCache) return difficultyIndexCache;
  difficultyIndexCache = new Map(
    Object.entries(TEAM_DIFFICULTY).map(([team, level]) => [resolveTeamKey(team), level])
  );
  return difficultyIndexCache;
}

/** Difficoltà (1-5) nell'affrontare la squadra indicata. */
export function getTeamDifficulty(teamName) {
  return buildDifficultyIndex().get(resolveTeamKey(teamName)) ?? DEFAULT_TEAM_DIFFICULTY;
}

// Correttivo casa/trasferta: la stessa avversaria è leggermente più facile da
// affrontare in casa e leggermente più dura in trasferta.
const HOME_AWAY_ADJUSTMENT = 0.5;

function adjustDifficultyForVenue(baseDifficulty, home) {
  const adjusted = baseDifficulty + (home ? -HOME_AWAY_ADJUSTMENT : HOME_AWAY_ADJUSTMENT);
  return Math.min(5, Math.max(1, adjusted));
}

/** Formatta un valore di difficoltà: "4" oppure "4.5". */
export function formatDifficultyValue(value) {
  const n = Number(value);
  if (value == null || !Number.isFinite(n)) return '—';
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

// Etichetta e colore per ciascun livello di difficoltà arrotondato (1-5),
// condivisi da tutte le viste che mostrano il calendario (dettaglio
// giocatore, analisi asta).
export const FIXTURE_DIFFICULTY_META = {
  1: { label: 'Molto facile', color: '#22c55e' },
  2: { label: 'Facile', color: '#84cc16' },
  3: { label: 'Media', color: '#fbbf24' },
  4: { label: 'Difficile', color: '#f97316' },
  5: { label: 'Molto difficile', color: '#ef4444' },
};

/** Colore associato a un valore di difficoltà (1-5, anche frazionario). */
export function getDifficultyColor(value) {
  if (value == null) return undefined;
  const rounded = Math.min(5, Math.max(1, Math.round(value)));
  return FIXTURE_DIFFICULTY_META[rounded].color;
}

// ─── Indice partite per squadra (costruito una volta sola) ───────────────────

let fixtureIndexCache = null;

function buildFixtureIndex() {
  if (fixtureIndexCache) return fixtureIndexCache;

  const index = new Map();
  SERIE_A_CALENDAR.forEach(({ giornata, date, matches }) => {
    matches.forEach(([home, away]) => {
      const entryHome = { giornata, date, opponent: away, home: true };
      const entryAway = { giornata, date, opponent: home, home: false };
      const homeKey = resolveTeamKey(home);
      const awayKey = resolveTeamKey(away);
      if (!index.has(homeKey)) index.set(homeKey, []);
      if (!index.has(awayKey)) index.set(awayKey, []);
      index.get(homeKey).push(entryHome);
      index.get(awayKey).push(entryAway);
    });
  });

  index.forEach((list) => list.sort((a, b) => a.giornata - b.giornata));
  fixtureIndexCache = index;
  return index;
}

// ─── API ──────────────────────────────────────────────────────────────────────

/** Tutte le partite (38) di una squadra, in ordine di giornata. */
export function getTeamFixtures(teamName) {
  return buildFixtureIndex().get(resolveTeamKey(teamName)) || [];
}

/**
 * Le prossime `count` partite di una squadra a partire da `now`.
 * Una giornata resta "prossima" fino alla fine del suo giorno di riferimento.
 * Prima dell'inizio del campionato ritorna le prime giornate; a stagione
 * conclusa ritorna [].
 */
export function getUpcomingTeamFixtures(teamName, count = 5, now = Date.now()) {
  const fixtures = getTeamFixtures(teamName);
  if (!fixtures.length) return [];

  const upcoming = fixtures.filter((f) => {
    const end = new Date(`${f.date}T23:59:59`).getTime();
    return end >= now;
  });

  return upcoming.slice(0, Math.max(0, count));
}

/**
 * Le prossime `count` partite di una squadra arricchite con la difficoltà.
 * `baseDifficulty` è il livello dell'avversario (1-5, da TEAM_DIFFICULTY);
 * `difficulty` lo corregge per il fattore campo (in casa -0.5, in trasferta
 * +0.5, sempre nel range 1-5).
 */
export function getUpcomingFixturesWithDifficulty(teamName, count = 5, now = Date.now()) {
  return getUpcomingTeamFixtures(teamName, count, now).map((fixture) => {
    const baseDifficulty = getTeamDifficulty(fixture.opponent);
    return {
      ...fixture,
      baseDifficulty,
      difficulty: adjustDifficultyForVenue(baseDifficulty, fixture.home),
    };
  });
}

/**
 * Difficoltà media del calendario di una squadra nelle prossime `count`
 * giornate (1-5, più alto = calendario più duro), già corretta per il
 * fattore casa/trasferta. Ritorna null se la squadra non è presente nel
 * calendario (es. giocatore trasferito all'estero).
 */
export function getUpcomingCalendarDifficulty(teamName, count = 5, now = Date.now()) {
  const fixtures = getUpcomingFixturesWithDifficulty(teamName, count, now);
  if (!fixtures.length) return null;

  const total = fixtures.reduce((acc, f) => acc + f.difficulty, 0);
  return total / fixtures.length;
}

/** Formatta la data di una giornata come "23/08". */
export function formatFixtureDate(date = '') {
  const [, m, d] = String(date).split('-');
  return d && m ? `${d}/${m}` : '—';
}
